module.exports = __webpack_public_path__ + "repunta_logo-2a9f6e339914c11113f4a056b8b198c1.png";